<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_client_setting_create'"></div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="300px">
                        <div class="dialog-form-item">
                            <el-form-item prop="clientSettingName" ref="clientSettingName">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_client_setting_name'"></span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="clientSettingName" size="large" type="text" placeholder="入力してください" v-model="inputItems.clientSettingName.value" :disabled="false"
                                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck('clientSettingName')"
                                          clearable @clear="inputCheckAll()"/>
                            </el-form-item>
                            <div v-if="settings.length != 0">
                                <el-form-item prep="copyClientSetting" ref="copyClientSetting">
                                    <div slot="label" style="text-align:left"><span v-t="'message.item_copy_client_setting'"></span></div>
                                    <el-switch class="enableSwitch" v-model="inputItems.copySettingId.enable" active-color="#5171cb" @change="handleChangeItems('copySettingId')"></el-switch>
                                </el-form-item>
                                <el-form-item prep="copySettingId" ref="copySettingId">
                                    <div slot="label" style="text-align:left"><span v-t="'message.item_copy_client_setting_name'"></span></div>
                                    <el-select class="select-option-item" ref="copySettingId" :disabled="!inputItems.copySettingId.enable" v-model="inputItems.copySettingId.value" v-on:change="handleChangeItems('copySettingId')" :placeholder="$t('message.place_holder_select_item')">
                                        <el-option v-for="setting in settings" :key="setting.settingId" :label="setting.settingName" :value="setting.settingId"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.$data.disableSave" @click="saveChange()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonValidate from '../../../common-validate.js';

export default {
    props: ['clientSettingList'],

    data() {
        return {
            inputItems: {
                clientSettingName: { enable: true,  validationRule: "clientSettingName",   valid: false, value: null, isComposing: false },
                copySettingId:     { enable: false, validationRule: "selectItem", valid: true,  value: null }
            },
            disableSave: false,
            settings: []
        };
    },

    created: function() {
        this.inputItems.clientSettingName.value = "";
        this.disableSave = true;
        if (this.clientSettingList.length > 0) {
            this.settings = this.clientSettingList;
        }
    },

    methods: {
        inputCheck(eventTargetId) {
            if ((this.inputItems[eventTargetId].isComposing) || (this.inputItems[eventTargetId].validationRule === null)) {
                // inputting with IME
                return;
            }
            let refInputItem = this.$refs[eventTargetId];
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputItems[eventTargetId].validationRule, this.inputItems[eventTargetId].value);
            if (validateResult.valid) {
                this.inputItems[eventTargetId].valid = true;
                refInputItem.clearValidate();
            } else {
                this.inputItems[eventTargetId].valid = false;
                refInputItem.validateState = "error";
                refInputItem.validateMessage = validateResult.message;
            }
            this.setButtonStatus();
        },
        inputCheckAll() {
            for (let targetId in this.inputItems) {
                if (this.inputItems[targetId].enable) {
                    this.inputCheck(targetId);
                }
            }
        },
        compositionStart(eventTargetId) {
            this.inputItems[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputItems[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId);
        },
        handleChangeItems(eventTargetId) {
            if (this.inputItems[eventTargetId].validationRule === null) {
                if (!this.inputItems[eventTargetId].enable) {
                    this.inputItems[eventTargetId].valid = true;
                }
                this.setButtonStatus();
                return;
            }
            let refInputItem = this.$refs[eventTargetId];
            if (this.inputItems[eventTargetId].enable) {
                this.inputCheck(eventTargetId);
            } else {
                this.inputItems[eventTargetId].value = null;
                this.inputItems[eventTargetId].valid = true;
                refInputItem.clearValidate();
            }
            this.setButtonStatus();
        },
        setButtonStatus() {
            if (commonValidate.checkFormValidation(this.inputItems)) {
                this.disableSave = false;
            } else {
                this.disableSave = true;
            }
        },
        saveChange: function() {
            this.$emit('save', {clientSettingName: this.$data.inputItems.clientSettingName.value, copySettingId: this.$data.inputItems.copySettingId.value });
        },
    }
}
</script scoped>

<style scoped>
.panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 600px;
    max-height: 80vh;
    margin-top: -40vh;
    margin-left: -300px;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -webkit-overflow-scrolling: touch;
    overflow: hidden;
}
</style>
